<template>
  <div>
   <!-- <shot-quality :game_id=158 :home_name="'Cardiff Devils'" :away_name="'Belfast Giants'"></shot-quality> 
  
  -->
  <!--<faceoffs-pvp :opponent=2 :game_id=167></faceoffs-pvp>-->
  <!-- <gamesheet></gamesheet>
  <realtime></realtime>
  <eihl-penalties></eihl-penalties> -->
  <game-faceoffs :gameId=211 :period=0></game-faceoffs>
  </div>
</template>
<script>

import ShotsHeatmap from './shots-heatmap.vue'
import Faceoffs from './match-faceoffs.vue'
import eihlShots from './season-stats/eihl_shotmap.vue'
import ShotQuality from './shots-quality.vue'
import _ from 'lodash'
import rtable from './rtable.vue'
import EIHLPenalties from './season-stats/eihl_penalties.vue'
import FaceoffsPVP from './season-stats/faceoffs-pvp.vue'
import Gamesheet from './gamesheet.vue'
import Realtime from './apex-realtime.vue'
export default {
  name: 'player',
  components: {
    'shots-heatmap': ShotsHeatmap,
    'eihl-shots': eihlShots,
    'rtable': rtable,
    'shot-quality': ShotQuality,
    'eihl-penalties': EIHLPenalties,
    'gamesheet': Gamesheet,
    'realtime': Realtime,
    'faceoffs-pvp': FaceoffsPVP,
    'game-faceoffs': Faceoffs
  },
  data: function () {
    return {
      Gamesheet: [],
      headings: [
        '#',
        '+',
        '-',
        '+/-',
        'SHOTS +',
        'SHOTS -',
        'SHOTS +/-',
        'SOT',
        'FO',
        'HITS',
        'SHIFTS',
        'AVG',
        'EH',
        'PP',
        'SH',
        'TOTAL'
      ]
    }
  },
  computed: {
    orderData () {
      let cleanData = []
      let GamesheetSelection = [
        'number',
        'goals_for',
        'goals_against',
        'goal_diff',
        'shots_for',
        'shots_against',
        'shots_plus_minus',
        'sot',
        'fo',
        'hits',
        'shifts',
        'avg_shift',
        'eh_time',
        'pp_time',
        'sh_time',
        'total_toi'
      ]
      // console.log(this.Faceoffs[0])
      _.map(this.Gamesheet, function (object) {
        console.log('obj' + object.position)
        if (object.position !== 'false' && object.position !== 'total') {
          cleanData.push(_.pick(object, GamesheetSelection))
        }
      })
      cleanData = _.orderBy(cleanData, 'shots_for', ['desc'])
      return cleanData
    }
  },
  methods: {
  },
  created () {

  }
}
</script>



// WEBPACK FOOTER //
// sandbox.vue?3b868c36